// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___YRRe","name":"styles_name__3LZVc","phone":"styles_phone__wV6lk"};